/**
 * Meta Pixel 유틸리티 (체험단 페이지용)
 *
 * frontend 트래커의 metaClient.ts 패턴을 경량화하여 구현.
 * - fbq stub 정의 → fbevents.js 비동기 로드
 * - autoConfig: false (자동 이벤트 수집 비활성화)
 * - trackSingle로 특정 Pixel에만 이벤트 전송
 */

// window.fbq 타입 선언
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

/**
 * Meta Pixel SDK 초기화
 *
 * fbq stub을 먼저 정의하고 fbevents.js를 비동기 로드한 뒤 init 호출.
 */
export function initPixel(pixelId: string): void {
  if (initialized) return

  // fbq stub 정의 (fbevents.js 로드 전에 먼저 존재해야 함)
  if (!window.fbq) {
    const fbq = function (...args: any[]) {
      if ((fbq as any).callMethod) {
        ;(fbq as any).callMethod.apply(fbq, args)
      } else {
        ;(fbq as any).queue.push(args)
      }
    } as any

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    window.fbq = fbq
    window._fbq = fbq
  }

  // fbevents.js 로드 (이미 로드된 스크립트가 없을 때만)
  if (
    !document.querySelector(
      'script[src*="connect.facebook.net"][src*="fbevents.js"]',
    )
  ) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  // Pixel 초기화 (autoConfig: false로 자동 이벤트 수집 비활성화)
  window.fbq('init', pixelId, {}, { autoConfig: false })

  initialized = true
}

/**
 * Meta Pixel 이벤트 발송
 *
 * trackSingle로 특정 Pixel에만 이벤트 전송 (다른 Pixel에 중복 전송 방지).
 */
export function trackPixelEvent(
  pixelId: string,
  eventName: string,
  data: Record<string, any>,
  eventId?: string,
): void {
  if (!window.fbq) return

  const options = eventId ? { eventID: eventId } : {}
  window.fbq('trackSingle', pixelId, eventName, data, options)
}
